import {VmButton, VmIcons, VmView} from 'components'
import ErrorLayout from 'components/layout/ErrorLayout'
import { ProgressFullScreen } from 'molecules'
import React, {useEffect, useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {fetchViewRujukanBpjs} from './api'
import moment from 'moment'
import { sleep } from 'pages/prd-penjualan-obat-resep/utils'
import { calcAgeYearOnly } from 'utils/calc-age'

export default function PrintRujukanBpjs() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const dctid = searchParams.get('dctid')
  const type = searchParams.get('type')
  const id = searchParams.get('id')
  
  const [data, setdata] = useState({
    noRujukan: '',
    ppk: {
      nmPPK: '',
      kdPPK: '',
      kc: {
        nmKC: '',
        kdKC: '',
        kdKR: {
          nmKR: ''
        }
      }
    },
    poli: {
      nmPoli: ''
    },
    ppkRujuk: {
      nmPPK: ''
    },
    nmPst: '',
    nokaPst: '',
    diag1: {
      nmDiag: ''
    },
    umur: '',
    tglLahir: '',
    pisa: '',
    sex: '',
    catatanRujuk: '',
    dokter: {
      nmDokter: ''
    },
    tglEstRujuk: '',
    jadwal: '',
    tglAkhirRujuk: ''
  })
  const [loading, setloading] = useState(false)
  const [error, seterror] = useState(false)
  const [isPrinting, setisPrinting] = useState(true)
  
  const handleBack = () => navigate(-1)
  const handleInit = async () => {
    setloading(true)
    // console.error('handleInit', id, type, dctid)
    const resData = await fetchViewRujukanBpjs({a: 'dk13', reg: 'dbdok', uid: dctid, noKunjungan: id})

    // localStorage.setItem('rujukanBpjs', JSON.stringify(resData))
    // const rujukanBpjs = JSON.parse(localStorage.getItem('rujukanBpjs'))

    console.error('Log:', resData)
    
    if (resData?.metaData?.code !== 200 || resData?.status == 0) {
      seterror({e: true, ...resData})
    } else {
      seterror(null)
      setdata({...resData?.response})
    }
    setloading(false)
  }

  const handlePrint = async () => {
    setisPrinting(true)
    await sleep(500)
    if (id && type && dctid && data?.noRujukan) {
      window.print()
      setisPrinting(false)
    }
  }

  useEffect(() => {
    handleInit()
    moment.locale('id')
  }, [])

  useEffect(() => {
    handlePrint()
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, type, dctid, data?.noRujukan])

  if (error?.e)
    return (
      <>
        <ProgressFullScreen visible={loading} />
        <ErrorLayout
          onBackPress={handleBack}
          showreload={true}
          onClickReload={handleInit}
          message={error?.metaData?.message || error?.message || 'Gagal saat mengambil data, silakan coba kembali!'}
        />
      </>
    )

  const isRujukan = !!data?.ppkRujuk?.nmPPK

  const renderWebBPJS = () => {
    return (
      <>
        <div className="page" style={{ width: '210mm', minHeight: '297mm', margin: '10mm auto', background: 'white', fontFamily: 'Arial', fontSize: 10 }}>
          {/* Header */}
          <div id="logo-bpjs" style={{ padding: '5px 20px', display: 'flex', alignItems: 'flex-start' }}>
            <img src="https://dokter.vmedis.com/logo/logo-bpjs.png" alt="" style={{ width: 200 }} />
            <div style={{ width: 500, marginLeft: 30 }}>
              <div style={{ marginTop: 7, float: 'right' }}>
                <table>
                  <tbody>
                    <tr>
                      <td style={{ fontSize: '1.2em', fontWeight: 'bold', width: 130 }}>Kedeputian Wilayah</td>
                      <td style={{ fontSize: '1.2em' }}>{data?.ppk?.kc?.kdKR?.nmKR || ''}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Kantor Cabang</td>
                      <td style={{ fontSize: '1.2em' }}>{data?.ppk?.kc?.nmKC || ''}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Title */}
          <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
            <p style={{ margin: 0, fontSize: '1.5em' }}>{isRujukan ? 'Surat Rujukan FKTP' : 'Data Kunjungan Puskesmas / Dokter Keluarga'}</p>
          </div>

          <div id="content" style={{ padding: '5px 20px', border: '1px solid black', marginLeft: 20, marginRight: 20 }}>
            {/* Section 1 */}
            <div className="inheader" style={{ border: '1px solid black', display: 'inline-block', width: '100%', fontSize: '1em' }}>
              <table className="grid-table" style={{ paddingLeft: 25, width: '50%', fontSize: '1em', float: 'left' }}>
                <tbody>
                  <tr className="itembpjs">
                    <td style={{ width: '40%' }}>{isRujukan ? 'No. Rujukan' : 'No. Kunjungan'}</td>
                    <td>: {data?.noRujukan || ''}</td>
                  </tr>
                  <tr className="itembpjs">
                    <td>{isRujukan ? 'FKTP' : 'Puskesmas / Dokter Keluarga'}</td>
                    <td>: {data?.ppk?.nmPPK ? `${data?.ppk?.nmPPK} (${data?.ppk?.kdPPK})` : ''}</td>
                  </tr>
                  <tr className="itembpjs">
                    <td>Kabupaten / Kota</td>
                    <td>: {data?.ppk?.kc?.nmKC ? `${data?.ppk?.kc?.nmKC} (${data?.ppk?.kc?.kdKC})` : ''}</td>
                  </tr>
                </tbody>
              </table>
              <h2 id="norujukan" className="half_left" style={{ fontSize: '2em', textAlign: 'center', fontWeight: 'bold', width: '50%', float: 'left', margin: 0 }}>
                {data?.noRujukan || ''}
              </h2>
              <div style={{ clear: 'both' }} />
            </div>

            {/* Section 2 */}
            <div className="inheader" style={{ paddingBottom: 0, display: 'inline-block', width: '100%', fontSize: '1em' }}>
              {isRujukan && (
                <>
                  <table className="grid-table" style={{ paddingLeft: 25, width: '50%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td style={{ width: '40%' }}>Kepada Yth. TS Dokter</td>
                        <td>: {data?.poli?.nmPoli || ''}</td>
                      </tr>
                      <tr className="itembpjs">
                        <td>Di</td>
                        <td>: {data?.ppkRujuk?.nmPPK || ''}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ clear: 'both' }} />
                  <table className="grid-tablefull" style={{ width: '100%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="grid-tablefull" style={{ marginTop: 15, paddingLeft: 25, width: '100%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td>Mohon pemeriksaan dan penanganan lebih lanjut pasien : </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )}
              <table className="grid-table" style={{ paddingLeft: 25, width: '50%', fontSize: '1em', float: 'left' }}>
                <tbody>
                  <tr className="itembpjs">
                    <td style={{ width: '40%' }}>Nama</td>
                    <td>: {data?.nmPst || ''}</td>
                  </tr>
                  <tr className="itembpjs">
                    <td>No. Kartu BPJS</td>
                    <td>: {data?.nokaPst || ''}</td>
                  </tr>
                  <tr className="itembpjs">
                    <td>Diagnosa</td>
                    <td>: {data?.diag1?.nmDiag || ''}</td>
                  </tr>
                  <tr className="itembpjs">
                    <td>Telah diberikan</td>
                    <td>:</td>
                  </tr>
                </tbody>
              </table>
              {/* <div style={{ clear: 'both' }} /> */}
              <table className="grid-table" style={{ width: '50%', fontSize: '1em', float: 'right' }}>
                <tbody>
                  <tr className="itembpjs">
                    <td style={{ width: '15%' }}>Umur :</td>
                    <td style={{ width: '10%' }}>{calcAgeYearOnly(moment(data?.tglLahir, 'DD-MM-YYYY').format('YYYY-MM-DD')) || ''}</td>
                    <td style={{ width: '25%', textAlign: 'center' }}>Tahun :</td>
                    <td style={{ width: '10%' }}></td>
                    <td style={{ width: '25%' }}>{data?.tglLahir || ''}</td>
                    <td style={{ width: '10%' }}></td>
                  </tr>
                  <tr className="itembpjs">
                    <td>Status :</td>
                    <td style={{ border: '2px solid black', textAlign: 'center' }}>{data?.pisa || ''}</td>
                    <td>Utama/Tanggunan</td>
                    <td></td>
                    <td style={{ textAlign: 'center' }}>
                      <div style={{ border: '2px solid black', width: 32, float: 'left' }}>{data?.sex || ''}</div>
                      <div style={{ width: 30, float: 'left' }}>(L/P)</div>
                    </td>
                    <td></td>
                  </tr>
                  {isRujukan && (
                    <tr className="itembpjs">
                      <td>Catatan : {data?.catatanRujuk || ''}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div style={{ clear: 'both' }} />
              <table className="grid-tablefull" style={{ width: '100%', fontSize: '1em', float: 'left' }}>
                <tbody>
                  <tr className="itembpjs">
                    <td style={{ width: '40%' }}></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div style={{ marginTop: 30, paddingLeft: 0, width: '60%', float: 'left' }}>
                {isRujukan ? 'Atas bantuannya, diucapkan terimakasih' : 'Demikian surat ini dibuat untuk dapat dipergunakan sebagaimana mestinya'}
              </div>
              <div style={{ marginTop: 30, paddingLeft: 35, width: '40%', float: 'right', textAlign: 'center' }}>
                <p>Salam sejawat,<br />{moment().format('DD MMMM YYYY')}</p>
              </div>
              <div style={{ clear: 'both' }} />
              <div style={{ marginTop: 30, width: '55%', float: 'left' }}>
                {data?.tglEstRujuk && (
                  <>
                    <p>Tgl. Rencana Berkunjung: &ensp; {data?.tglEstRujuk || ''}</p>
                    <p>Jadwal Praktek: &ensp; {data?.jadwal || ''}</p>
                  </>
                )}
                <p>
                  Surat Rujukan berlaku 1[satu] kali kunjungan, berlaku sampai dengan :{' '}
                  {data?.tglAkhirRujuk || ''}
                </p>
              </div>
              <div style={{ paddingLeft: 35, width: '40%', float: 'right', textAlign: 'center' }}>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>{data?.dokter?.nmDokter || ''}</p>
              </div>
              <div style={{ clear: 'both' }} />
            </div>
            
            {type === 'balik' && (
              <>
                {/* Separator */}
                <hr style={{ borderTop: '1px solid black', marginTop: 20, width: 'calc(100% + 40px)', marginLeft: -20 }} />

                {/* Surat Rujukan Balik */}
                <div className="inheader" style={{ paddingBottom: 0, display: 'inline-block', width: '100%', fontSize: '1em' }}>
                  <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <p style={{ textDecoration: 'underline', margin: 0, fontSize: '1.5em' }}>Surat Rujukan Balik</p>
                  </div>
                  <table className="grid-tablefull" style={{ marginTop: 15, paddingLeft: 25, width: '100%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td style={{ width: '40%' }}>
                          Teman sejawat Yth.<br />Mohon kontrol selanjutnya penderita :
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="grid-table" style={{ paddingLeft: 50, width: '50%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td style={{ width: '40%' }}>Nama</td>
                        <td>: {data?.nmPst || '........................................'}</td>
                      </tr>
                      <tr className="itembpjs">
                        <td>Diagnosa</td>
                        <td style={{ width: '40%' }}>: ........................................</td>
                      </tr>
                      <tr className="itembpjs">
                        <td>Terapi</td>
                        <td style={{ width: '40%' }}>: ........................................</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ clear: 'both' }} />
                  <table className="grid-tablefull" style={{ width: '100%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td style={{ width: '40%' }}></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ marginTop: 30, paddingLeft: 0, width: '50%', float: 'left' }}>
                    Tindak lanjut yang dianjurkan
                  </div>
                  <div style={{ clear: 'both' }} />

                  <table className="grid-table" style={{ paddingLeft: 25, marginTop: 15, width: '50%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs" style={{ marginTop: 10 }}>
                        <td style={{ border: '2px solid black', width: '2%' }}></td>
                        <td style={{ width: '15%' }}>Pengobatan dengan obat- obatan : ........................................</td>
                      </tr>
                      <tr></tr>
                      <tr className="itembpjs" style={{ marginTop: 10 }}>
                        <td style={{ border: '2px solid black', width: '2%' }}></td>
                        <td style={{ width: '15%' }}>Kontrol kembali ke RS tanggal : ........................................</td>
                      </tr>
                      <tr></tr>
                      <tr className="itembpjs" style={{ marginTop: 10 }}>
                        <td style={{ border: '2px solid black', width: '2%' }}></td>
                        <td style={{ width: '15%' }}>Lain-lain : ........................................</td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ clear: 'both' }} /> */}
                  <table className="grid-table" style={{ paddingLeft: 25, marginTop: 15, width: '50%', fontSize: '1em', float: 'left' }}>
                    <tbody>
                      <tr className="itembpjs">
                        <td style={{ border: '2px solid black', width: '2%' }}></td>
                        <td style={{ width: '15%' }}>Perlu Rawat Inap</td>
                      </tr>
                      <tr></tr>
                      <tr className="itembpjs">
                        <td style={{ border: '2px solid black', width: '2%' }}></td>
                        <td style={{ width: '15%' }}>Konsultasi selesai</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ clear: 'both' }} />
                  <div style={{ marginTop: 100, paddingLeft: 60, width: '40%', float: 'right', textAlign: 'center' }}>
                    <p>..........................tgl...........................</p>
                    <p>Dokter RS,</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>(.....................................................)</p>
                  </div>
                  <div style={{ clear: 'both' }} />
                </div>
              </>
            )}
          </div>

          {/* Footer */}
          {!isPrinting && (
            <VmView className="flex flex-row justify-between items-center px-4 py-4">
              <VmButton
                className="mr-2"
                onClick={() => navigate('/prd-tra-pemeriksaan-pasien/search?dctid=' + dctid)}
                color="danger"
                size="small"
              >
                Kembali
              </VmButton>
              <VmButton
                onClick={() => handlePrint()}
                color="warning"
                size="small"
              >
                <VmView className="flex flex-row items-center">
                  <VmIcons
                    name="VmPrinterIcon"
                    size={20}
                    className="self-center mr-2"
                  />
                  Cetak
                </VmView>
              </VmButton>
            </VmView>
          )}
        </div>
      </>
    )
  }

  return <div className="w-[210mm]">{renderWebBPJS()}</div>
}
